export const modalModes = {
  approve: 'approve',
  decline: 'decline',
}
